export const CountriesWithPrefix = ['FR', 'ES', 'DE', 'RO', 'PL', 'NL'];
export const VATField = 'VAT-field';
